(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name itecAdministracio.shared.filters.filter:percentatge
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.shared.filters')
    .filter('percentatge', percentatgeFilter);

  function percentatgeFilter($filter) {
    return function (input, decimals) {
      if (input === null) {
        input = 0;
      }
      return $filter('number')(input, decimals) + '%';
    }
  }
}());